import { stepRating } from '../domain/drink-search';
import { t, tf } from '../i18n';

/**
 * The rating with an up and a down arrow (owner request, 2026-10-06): half points from 5 down to
 * 1, then "Pas de note"; the up arrow stops at 5, the down arrow at "Pas de note"
 * (domain/drink-search.ts). The value is announced as it changes.
 */
export function RatingStepper({
  label,
  value,
  onChange,
}: {
  label: string;
  value: number | undefined;
  onChange: (value: number | undefined) => void;
}) {
  return (
    <div className="rating-stepper" role="group" aria-label={label}>
      <span className="rating-stepper__label">{label}</span>
      <button
        type="button"
        aria-label={t('rating.down')}
        disabled={value === undefined}
        onClick={() => onChange(stepRating(value, 'down'))}
      >
        ▼
      </button>
      <output className="rating-stepper__value" aria-live="polite">
        {value === undefined
          ? t('rating.noRating')
          : tf('rating.outOfFive', { rating: String(value) })}
      </output>
      <button
        type="button"
        aria-label={t('rating.up')}
        disabled={value === 5}
        onClick={() => onChange(stepRating(value, 'up'))}
      >
        ▲
      </button>
    </div>
  );
}
